import React, { useCallback, useEffect } from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { ButtonLink } from '@change-corgi/design-system-legacy/components/actions';
import { Flex } from '@change-corgi/design-system-legacy/layout';

import { useCampaignTracking } from 'src/app/shared/hooks/campaignTracking';

type Props = {
	petitionId: string;
	slug: string;
};

export const ViewPetitionFeed: React.FC<Props> = ({ petitionId, slug }) => {
	const { track } = useCampaignTracking();

	const trackViewAllClick = useCallback(() => {
		track('campaign_action_supporter_voices_view_all_click', { petition_id: petitionId });
	}, [petitionId, track]);

	useEffect(() => {
		track('campaign_action_supporter_voices_view_all_view', { petition_id: petitionId });
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Flex sx={{ justifyContent: 'center' }}>
			<ButtonLink
				data-testid="supporter-voices-view-all"
				data-qa="supporter-voices-view-all"
				to={`/p/${slug}/feed`}
				variant="secondary"
				my={0}
				sx={{ width: ['100%', 'auto'] }}
				onClick={trackViewAllClick}
			>
				<Translate value="corgi.petition_gamma.videos.view_all" />
			</ButtonLink>
		</Flex>
	);
};
